// Respaldo bilingue de los avisos de la familia "cuenta": sesion, contrasena,
// alta y datos personales.
//
// POR QUE EXISTE: estos avisos estaban escritos en espanol dentro del codigo,
// asi que quien tenia la interfaz en ingles leia "Tu sesion expiro..." o
// "Selecciona una imagen JPG, PNG o WebP." en medio de una pantalla en ingles.
// Unos son el `||` que cubre una clave del esquema remoto (/api/lang/sch) que
// hoy no llega, y otros —el de sesion expirada— no tienen clave publicada en
// ningun idioma.
//
// COMO SE RETIRA: el esquema remoto SIEMPRE gana donde hay clave; el dia que
// backend publique AL0024, AL0047, AL0049, AL0018/AL0019 y ER0118 estos
// respaldos dejan de usarse solos. El de sesion expirada necesita ademas una
// clave nueva.
//
// OJO: `sessionExpired` se pinta cuando la sesion YA se limpio. Por eso
// `clearSessionData` conserva la preferencia de idioma: si se borrara junto con
// el token, la pantalla de login volveria siempre a ingles y este texto no
// tendria idioma que respetar.

import { normalizeInterfaceLanguage } from "../interfaceLanguage";

const accountMessages = {
  es: {
    sessionExpired: "Tu sesión expiró. Inicia sesión nuevamente para continuar.",
    passwordMinLength: "Al menos 8 caracteres",
    passwordRecoverySent:
      "Si tu correo está en nuestros registros, te enviaremos un mensaje para recuperar tu contraseña.",
    acceptTerms: "Acepta los términos y condiciones",
    resendEmailMissing: "Correo no capturado para reenviar verificación.",
    resendEmailSent: "Correo de verificación reenviado.",
    resendEmailFailed: "Error al reenviar el correo de verificación.",
    ssoFailed: "No se pudo iniciar sesión.",
    ssoModalTitle: "Para poder continuar\ninicia sesión en viva nomada",
    deleteAccountFailed: "Error al eliminar la cuenta.",
    paymentCompleted: "Pago completado.",
    imageFormat: "Selecciona una imagen JPG, PNG o WebP.",
    lettersOnly: "Solo se permiten letras y espacios.",
    ageRange: "La edad debe ser un número entre 0 y 99.",
  },
  en: {
    sessionExpired: "Your session expired. Sign in again to continue.",
    passwordMinLength: "At least 8 characters",
    passwordRecoverySent:
      "If your email is in our records, we will send you a message to recover your password.",
    acceptTerms: "Accept the terms and conditions",
    resendEmailMissing: "No email was captured to resend the verification.",
    resendEmailSent: "Verification email sent.",
    resendEmailFailed: "Could not resend the verification email.",
    ssoFailed: "Could not sign in.",
    ssoModalTitle: "To continue,\nsign in to viva nomada",
    deleteAccountFailed: "Could not delete the account.",
    paymentCompleted: "Payment completed.",
    imageFormat: "Choose a JPG, PNG or WebP image.",
    lettersOnly: "Only letters and spaces are allowed.",
    ageRange: "Age must be a number between 0 and 99.",
  },
};

export const getAccountMessages = (language) =>
  accountMessages[normalizeInterfaceLanguage(language)];
